import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, PropType, nextTick } from 'vue'
 
    
export default /*@__PURE__*/_defineComponent({
  __name: 'money_input',
  props: {
        disabled: {
            type: Boolean as PropType<boolean>,
            default() {
                return false
            }
        },
        modelValue: {
            type: [String, Number, null]
        }
    },
  emits: ['input', 'update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

    const props = __props

    const emit = __emit

    const prop_value = computed(() => props.modelValue)
    const prop_disabled = computed(() => props.disabled)

    function is_numeric(str: number | string): boolean {
        if (typeof str == "number") return true
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str as unknown as number) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    function display_currency(money: number | string): string {
        if(typeof money == "undefined"
            || money === null
            || !is_numeric(money)
        ) {
            return ""
        }

        if (typeof money === "string") {
            money = parseFloat(money)
        }

        return money.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }

    const dat_text = ref('$0.00')
    const dat_error = ref(false)
    const dat_focused = ref(false)

    function focusout() {
        let loc_currency = display_currency(dat_text.value)
        if (loc_currency == "") {
            // dat_text.value = "$0.00"
            // dat_error.value = false
        } else {
            dat_text.value = loc_currency
        }
        dat_focused.value = false
    }

    function get_cursor_digit_position(element: HTMLInputElement): number {
        const cursor_index = element.selectionStart || 0;
        const left_part = element.value.slice(0, cursor_index);
        return (left_part.match(/[0-9.]/g) || []).length;
    }

    function set_cursor_to_digit_position(element: HTMLInputElement, digit_pos: number) {
        nextTick().then(() => {
            element.setSelectionRange(digit_pos, digit_pos);
        })
    }

    function focusin(event: Event, arg_error: boolean) {
        const target = event.target as HTMLInputElement

        // Strip formatting (remove all non-digit and non-decimal)
        if (!arg_error) {
            // Get current cursor position (in digits)
            let cursor_digit_pos = get_cursor_digit_position(target);
            
            dat_text.value = dat_text.value.replace(/[^\d.]/g, '')

            // Restore cursor position
            set_cursor_to_digit_position(target, cursor_digit_pos);
        }

        dat_focused.value = true
    }

    function input(event: Event) {
        const loc_input_element = event.target as HTMLInputElement
        const loc_value = loc_input_element.value

        if (is_numeric(loc_value)) {
            dat_error.value = false
            emit('update:modelValue', loc_value)
            emit('input', loc_value)
        } else {
            dat_error.value = true
        }
    }

    function classes(arg_error) {
        if (arg_error) {
            return [
                'dark:bg-dark-900',
                'shadow-theme-xs',
                'dark:focus:border-brand-800',
                'h-11',
                'w-full',
                'rounded-lg',
                'border',
                'border-red-500',
                'bg-transparent',
                'px-4',
                'py-2.5',
                'text-sm',
                'text-red-800',
                'placeholder:text-gray-400',
                'focus:outline-hidden',
                'dark:border-gray-700',
                'dark:bg-gray-900',
                'dark:text-white/90',
                'dark:placeholder:text-white/30'
            ]
        } else {
            return [
                'dark:bg-dark-900',
                'shadow-theme-xs',
                'focus:border-brand-300',
                'focus:ring-brand-500/10',
                'dark:focus:border-brand-800',
                'h-11',
                'w-full',
                'rounded-lg',
                'border',
                'border-gray-300',
                'bg-transparent',
                'px-4',
                'py-2.5',
                'text-sm',
                'text-gray-800',
                'placeholder:text-gray-400',
                'focus:ring-3',
                'focus:outline-hidden',
                'dark:border-gray-700',
                'dark:bg-gray-900',
                'dark:text-white/90',
                'dark:placeholder:text-white/30'
            ]
        }
    }

    watch(prop_value, (arg_value) => {
        if (dat_focused.value) {    
            return
        }

        if (arg_value === null
            || typeof arg_value == 'undefined'
        ) {
            dat_text.value = ""
        } else {
            let loc_currency = display_currency(arg_value)
            if (loc_currency == "") {
                dat_text.value = "$0.00"
            } else {
                dat_text.value = loc_currency
            }
            dat_error.value = false
        }
    })


const __returned__ = { props, emit, prop_value, prop_disabled, is_numeric, display_currency, dat_text, dat_error, dat_focused, focusout, get_cursor_digit_position, set_cursor_to_digit_position, focusin, input, classes }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})